<div
  class="small-pair truncate max-w-[200px]"
  [ngClass]="{
    'ddc-small-word-light': _isLightTheme || _isPaperTheme,
    'ddc-small-word-dark': _isDarkTheme,
  }"
>
  <div class="small-pair-1" *ngIf="_withIcon">
    <span class="material-icons ddc-chip-icon"> fiber_smart_record </span>
  </div>
  <div class="small-pair-2">
    <div class="truncate max-w-[200px]">{{ _pair.word_1?.word ? _pair.word_1.word : _pair }}</div>
    <!-- <div>{{_pair.word_1.word? _pair.word_1.word : _pair}}</div> -->
    <!-- <div *ngIf="_isString">{{_pair}}</div> -->
    <div class="between-divider" *ngIf="_pair.word_1?.word">•</div>
    <div class="truncate max-w-[200px]" *ngIf="_pair.word_2?.word">{{ _pair.word_2.word }}</div>
  </div>
</div>
